import styled from "styled-components";
import {Grid, InputLabel, TextField} from "@material-ui/core";

export const LogoPreview = styled.img`
  max-width: 75px;
  max-height: 75px;
  display: block;
  margin-right: 16px;
`;

export const LogoControlGrid = styled(Grid)`
  && {
    width: fit-content;
    min-height: 75px;
  }
`;

export const LogoInputLabel = styled(InputLabel)`
  && {
    font-size: 13px;
    padding-bottom: 4px;
  }
`;

export const LogoInput = styled(TextField)`
  && {
    display: none;
  }
`;
